import { render, staticRenderFns } from "./CustomerOrderOperations.vue?vue&type=template&id=a755b636&scoped=true&"
import script from "./CustomerOrderOperations.vue?vue&type=script&lang=js&"
export * from "./CustomerOrderOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a755b636",
  null
  
)

export default component.exports